import { Container, Row, Col } from 'react-bootstrap';

export default function Home() {
    return <Container className='mb-5'>
        <Row>
            <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="/institucional">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/institucional.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            INSTITUCIONAL
                        </Col>
                    </Row>
                </a>
            </Col>
            <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="/ouvidoria">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/ouvidoria.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            SISTEMA DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA
                        </Col>
                    </Row>
                </a>
            </Col>
            <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="https://www.alepe.pe.gov.br/carta-de-servicos/" target="_blank" rel="noopener noreferrer">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/carta-servicos.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            CARTA DE SERVIÇOS
                        </Col>
                    </Row>
                </a>
            </Col>
            <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="/legislacao">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/legislacao.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            LEGISLAÇÃO
                        </Col>
                    </Row>
                </a>
            </Col>
            <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="/pessoal">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/pessoal.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            GESTÃO DE PESSOAS
                        </Col>
                    </Row>
                </a>
            </Col>
            <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="/financas">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/financas.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            PRESTAÇÃO DE CONTAS
                        </Col>
                    </Row>
                </a>
            </Col>
            <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="/dados-pessoais/lgpd-alepe">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/dados-pessoais.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            PROTEÇÃO DE DADOS PESSOAIS (LGPD)
                        </Col>
                    </Row>
                </a>
            </Col>
            <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="https://dadosabertos.alepe.pe.gov.br/" target="_blank">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/dados-abertos.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            DADOS ABERTOS
                        </Col>
                    </Row>
                </a>
            </Col>
            {/* <Col md="4" className="text-center" style={{'margin-top': '50px'}}>
                <a href="/faq">
                    <Row>
                        <Col xs="12">
                            <img className="logo-header" src="/img/faq.png"/>
                        </Col>
                        <Col xs="12" className='text-center'>
                            FAQ
                        </Col>
                    </Row>
                </a>
            </Col> */}
        </Row>
    </Container>
}
